import { render, staticRenderFns } from "./MessageNotifier.vue?vue&type=template&id=1484c195&scoped=true"
import script from "./MessageNotifier.vue?vue&type=script&lang=js"
export * from "./MessageNotifier.vue?vue&type=script&lang=js"
import style0 from "./MessageNotifier.vue?vue&type=style&index=0&id=1484c195&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1484c195",
  null
  
)

export default component.exports